module.exports = __webpack_public_path__ + "img/buyerES.9e6cc5cf.png";